<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Add Stock",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      title: "Add To Stock",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Add Stock",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item.drug",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "itemQty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL PRICE",
        },
        {
          key: "batchNo",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "expiryDate",
          sortable: true,
          label: "EXPIRY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],

      // Value from user input for adding position
      data: {
        item: "",
        quantity: "",
        unit_price: "",
        batch_no: "",
        expiry_date: "",
        supplier_id: "",
      },
      itemError: "",
      quantityError: "",
      unit_priceError: "",
      batch_noError: "",
      expiry_dateError: "",
      totals: {
        paid: "",
        total: "",
        sup: "",
        mode: "",
        invoice: "",
      },
      // edit item
      editdata: {
        id: "",
        item: "",
        name: "",
        quantity: "",
        batch: "",
        expiry: "",
        price: "",
      },
      editsup: {
        sup_id: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      modeError: "",
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapState("pharmacy", ["total_cart"]),
    ...mapGetters("pharmacy", [
      "PharmacyItems",
      "DispenseState",
      "Suppliers",
      "StockCart",
      "TotalCart",
    ]),
    ...mapGetters("payments", ["PaymentModes"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.StockCart ? this.StockCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    this.totals.paid = this.TotalCart.total;
    this.totals.total = this.TotalCart.total;
    this.totals.sup = this.TotalCart.supplier_id;
    // Set the initial number of items
    this.totalRows = this.StockCart ? this.StockCart.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.resetData();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    total_cart(newValue) {
      if (newValue) {
        this.totals.paid = this.TotalCart.total;
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCart: "pharmacy/fetchCart",
      FetchItems: "pharmacy/fetchPharmacyItems",
      FetchSuppliers: "pharmacy/fetchSuppliers",
      AddCart: "pharmacy/addToCart",
      DeleteCartItem: "pharmacy/deleteCart",
      FetchTotal: "pharmacy/fetchTotCart",
      EditCartItems: "pharmacy/editCart",
      EditSupplier: "pharmacy/editSup",
      SavePurchase: "pharmacy/savePurch",
      FetchModes: "payments/fetchPaymentModes",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkItem() {
      if (this.data.item != "") {
        this.existingItem = this.StockCart.filter((item) => {
          return item.item.id == this.data.item;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetData() {
      this.data.item = "";
      this.data.unit_price = "";
      this.data.batch_no = "";
      this.data.expiry_date = "";
      this.data.supplier_id = "";
      this.data.quantity = "";
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetEditSup(modalId) {
      this.closeModal(modalId);
      this.editsup.sup_id = "";
      this.modal_id = "";
    },

    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.name = "";
      this.editdata.item = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.expiry = "";
      this.editdata.batch = "";
      this.editdata.price = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.quantityError = "";
      this.unit_priceError = "";
      this.batch_noError = "";
      this.expiry_dateError = "";
    },

    showEditModal(data) {
      this.editdata.name = data.item.drug;
      this.editdata.item = data.item.id;
      this.editdata.id = data.id;
      this.editdata.quantity = data.itemQty;
      this.editdata.expiry = data.expiryDate;
      this.editdata.batch = data.batchNo;
      this.editdata.price = data.unitPrice;
    },

    showEditSupModal(data) {
      this.editsup.sup_id = data.supplier_id;
    },

    showSuspendModal(user) {
      this.suspenddata.name = user.name;
      this.suspenddata.id = user.id;
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.drug;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    editSupp(modalId) {
      this.modal_id = modalId;
      this.EditSupplier(this.editsup);
    },
    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    savePurchase() {
      if (this.totals.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      if (this.totals.paid == "") {
        this.totals.paid = 0;
      }
      this.SavePurchase(this.totals);
    },
    resetmodeError() {
      this.modeError = "";
    },
    addToCart() {
      if (this.data.item == "") {
        this.itemError = "Item Field is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.item == "") {
        this.itemError = "Item Field is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity Purchased is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.data.unit_price == "") {
        this.unit_priceError = "Unit Price Field is required";
        return;
      } else {
        this.unit_priceError = "";
      }
      if (this.data.batch_no == "") {
        this.batch_noError = "Batch Number Field is required";
        return;
      } else {
        this.batch_noError = "";
      }
      if (this.data.expiry_date == "") {
        this.expiry_dateError = "Expiry Date is required";
        return;
      } else {
        this.expiry_dateError = "";
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      this.AddCart(this.data);
    },
    editUser(modalId) {
      this.modal_id = modalId;
      this.EditRole(this.editdata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchSuppliers();
    this.FetchItems();
    this.FetchCart();
    this.FetchTotal();
    this.FetchModes();
  },
  updated() {
    this.totals.total = this.TotalCart.total;
    this.totals.sup = this.TotalCart.supplier_id;
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="StockCart ? StockCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.unitPrice
                      ? thousandSeprator(data.item.unitPrice * data.item.itemQty)
                      : 0
                  }}
                </template>

                <template #cell(unit_price)="data">
                  {{ data.item.unitPrice ? thousandSeprator(data.item.unitPrice) : 0 }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    class="m-2"
                    @click="showEditModal(data.item)"
                    >Edit</b-button
                  >
                  <b-button
                    v-b-modal.delete-item-modal
                    variant="danger"
                    size="sm"
                    @click="showDeleteModal(data.item)"
                    >Delete</b-button
                  >
                </template>
              </b-table>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
              <center>
                <h3 v-if="!StockCart" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>

            <div class="row" v-if="TotalCart.total > 0">
              <div class="col-12 text-center mt-4">
                <h4>
                  <strong
                    >TOTAL:
                    {{
                      TotalCart.total ? thousandSeprator(TotalCart.total) : 0
                    }}/=</strong
                  >
                </h4>
                <h5>
                  <strong class="mr-3">Supplier: {{ TotalCart.supplier_name }}</strong>
                  <i
                    v-b-modal.edit-sup-modal
                    @click="showEditSupModal(TotalCart)"
                    class="btn btn-primary btn-sm ml-3 fa fa-edit"
                  ></i>
                </h5>
              </div>
            </div>

            <b-form v-show="StockCart.length" class="mt-3">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Amount Paid</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model="totals.paid"
                      min="0"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Invoice/Receipt No.</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.invoice"
                      min="0"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Payment Method</label>
                    <model-list-select
                      :list="PaymentModes ? PaymentModes : []"
                      v-model="totals.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Method"
                      @input="resetmodeError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="modeError">
                    <em>{{ modeError }}</em>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-md-6"></div>
                <div class="col-md-6">

                  <b-button  variant="primary" class="float-end" @click="savePurchase()"
                    ><i class="fa fa-check"></i> Save Purchase
                    <b-spinner
                      v-if="DispenseState"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>

                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Add To Cart</h4>
            <form action="">
              <div class="form-group mb-3">
                <label>Item</label>
                <model-list-select
                  :list="PharmacyItems ? PharmacyItems : []"
                  v-model="data.item"
                  option-value="id"
                  option-text="drug_name"
                  placeholder="Select Item"
                  @input="resetErrors(), checkItem()"
                  @change="checkItem()"
                >
                </model-list-select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Quantity</label>
                <input
                  type="number"
                  class="form-control"
                  step="any"
                  v-model="data.quantity"
                  @input="resetErrors()"
                  placeholder="Enter Quantity"
                />
                <div class="text-danger" v-if="quantityError">
                  <em>{{ quantityError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Unit Price</label>
                <input
                  type="number"
                  class="form-control"
                  step="any"
                  v-model="data.unit_price"
                  @input="resetErrors()"
                  placeholder="Enter Unit Price"
                />
                <div class="text-danger" v-if="unit_priceError">
                  <em>{{ unit_priceError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Batch Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.batch_no"
                  @input="resetErrors()"
                  placeholder="Enter Batch Number"
                />
                <div class="text-danger" v-if="batch_noError">
                  <em>{{ batch_noError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Expiry Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="data.expiry_date"
                  @input="resetErrors()"
                />
                <div class="text-danger" v-if="expiry_dateError">
                  <em>{{ expiry_dateError }}</em>
                </div>
              </div>
              <div
                class="form-group mb-3"
                v-if="StockCart ? StockCart.length < 1 : false"
              >
                <label>Supplier</label>
                <model-list-select
                  :list="Suppliers ? Suppliers : []"
                  v-model="data.supplier_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                >
                </model-list-select>
              </div>
              <div class="form-group text-center">
                <b-button
                  v-if="user_permissions.add_stock"
                  @click="addToCart()"
                  variant="primary"
                  ><i class="fa fa-plus"></i> Add
                  <b-spinner
                    v-if="DispenseState"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()">
      <template #modal-title class="text-primary">
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Item</label>
        <model-list-select
          :list="PharmacyItems ? PharmacyItems : []"
          v-model="editdata.item"
          option-value="id"
          option-text="drug_name"
          placeholder="Select Role"
        >
        </model-list-select>
      </div>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
        />
      </div>
      <div class="form-group mb-3">
        <label>Unit Price</label>
        <input type="number" class="form-control" step="any" v-model="editdata.price" />
      </div>
      <div class="form-group mb-3">
        <label>Batch Number</label>
        <input type="text" class="form-control" v-model="editdata.batch" />
      </div>
      <div class="form-group mb-3">
        <label>Expiry Date</label>
        <input type="date" class="form-control" v-model="editdata.expiry" />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="DispenseState"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal edit supplier starts -->
    <b-modal id="edit-sup-modal" hide-footer @hidden="resetEditSup">
      <template #modal-title> Edit Supplier</template>
      <div class="form-group mb-3">
        <label>Supplier</label>
        <model-list-select
          :list="Suppliers ? Suppliers : []"
          v-model="editsup.sup_id"
          option-value="id"
          option-text="name"
          placeholder="Select Supplier"
        >
        </model-list-select>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-sup-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="editSupp('edit-sup-modal')">
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="DispenseState"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem">
      <template #modal-title class="text-danger"> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="DispenseState"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
